import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 240px;
  width: calc(100% - 400px);
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: hidden;

  .__react_component_tooltip {
    text-align: center;
    font-weight: 400;
  }

  ${mediaMaxWidth.smallDesktop} {
    flex: unset;
    height: 270px;
    margin: 10px auto;
    width: 650px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    height: 280px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

export const TitleText = styled.div`
  ${mediaMaxWidth.phone} {
    width: calc(100vw - 55px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Tooltip = styled.div`
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    font-size: 0.85em;
    color: rgb(187, 187, 187);
    transition: all 0.1s ease-in-out 0s;
  }

  ${mediaMaxWidth.smallDesktop} {
    display: none;
  }
`;

export const Engagements = styled.div`
  flex: 1;
  flex-direction: column;
  margin-top: 10px;
`;

export const Placements = styled.div`
  margin-top: 10px;
  flex: 1;
  flex-direction: column;
  position: relative;
`;

export const MobileTitle = styled.div`
  text-transform: capitalize;
  font-size: 0.875em;
  font-style: italic;

  ${mediaMinWidth.smallDesktop} {
    display: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 0 10px;
  position: relative;
  height: 100%;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    flex-direction: column;
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 5px 0 5px;
  }
`;

export const ListItem = styled.div`
  display: flex;
  height: 44.25px;
  align-items: center;
  font-size: 0.95em;

  svg.fa-check {
    color: #27ae60;
  }

  svg.fa-trophy {
    color: #eda225;
  }
`;

export const ListItemText = styled.div`
  padding-left: 15px;
  width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.smallDesktop} {
    width: 595px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 70px);
  }
`;

export const ViewMore = styled.div`
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  height: 55px;
  z-index: 1;
  align-items: center;
  background-color: #fff;

  ${mediaMaxWidth.smallDesktop} {
    display: none;
  }
`;

export const MobileViewMore = styled.div`
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  height: 55px;
  align-items: center;
  background-color: #fff;
  z-index: 1;

  ${mediaMinWidth.smallDesktop} {
    display: none;
  }
`;

export const ViewMoreButton = styled.div`
  font-size: 0.85em;
  text-transform: capitalize;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #79D9D9;
  }
`;

export const EngagementsPlaceholder = styled.div`
  width: 100%;
  background-color: #fff;
  position: absolute;
  left: 0;
  height: 100%;
  z-index: 2;
  top: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  svg {
    font-size: 3em;
  }
`;

interface IPlacementsPlaceholderProps {
  placements: number;
}

export const PlacementsPlaceholder = styled.div`
  width: 100%;
  background-color: #fff;
  position: absolute;
  left: 0;
  height: 100%;
  z-index: 1;
  top: 0;
  justify-content: ${(props: IPlacementsPlaceholderProps) =>
    props.placements > 3 ? "flex-start" : "center"};
  display: flex;
  flex-direction: column;
`;

export const PlaceholderText = styled.div`
  font-size: 0.95em;
  text-align: center;
  padding: ${(props: IPlacementsPlaceholderProps) =>
    props.placements ? "10px 50px" : "10px 40px"};

  ${mediaMaxWidth.phone} {
    padding: 10px 20px;
  }
`;
